function beaconFeeAmount (routeFare) {
  const surcharges = routeFare && routeFare.surcharges
  const entry = surcharges && surcharges.beaconMaintenanceFee
  const fee = entry && Number(entry.amount)
  if (!Number.isFinite(fee) || fee <= 0) {
    return 0
  }
  return fee
}

function fareSearchStopParams (origin, destination) {
  const hasDestination = destination && destination.longlat
  return {
    startLongitude: origin.longlat[0],
    startLatitude: origin.longlat[1],
    endLongitude: hasDestination ? destination.longlat[0] : undefined,
    endLatitude: hasDestination ? destination.longlat[1] : undefined,
    busStopIdFrom: origin.id,
    busStopIdTo: destination ? destination.id : undefined
  }
}

function buildOneTimeTicketFarePreview (routeFare, formatAmount) {
  const fare = Number(routeFare && routeFare.fare)
  const total = Number.isFinite(fare) ? fare : 0
  const fee = beaconFeeAmount(routeFare)
  const showBreakdown = fee > 0 && total > fee
  const routeAmount = showBreakdown ? total - fee : total
  const format = typeof formatAmount === 'function' ? formatAmount : String
  const totalLabel = format(total)
  const breakdownLabel = showBreakdown
    ? format(routeAmount) + ' + surcharges (' + format(fee) + ' beacon maintenance fee)'
    : ''

  return {
    totalLabel: totalLabel,
    breakdownLabel: breakdownLabel
  }
}

module.exports = {
  fareSearchStopParams: fareSearchStopParams,
  buildOneTimeTicketFarePreview: buildOneTimeTicketFarePreview
}
